import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Card } from "antd";
import HeaderComponent from "components/card/HeaderComponent";
import { USABLE_ICONS, CORE_VALUE_META } from "variables/constants";
import {
  getCoreValuesList
} from "../../../../redux/optionlist/optionlistState";

const OurCoreValues = ({
  doGetCoreValuesList,
  coreValuesList
}) => {

  useEffect(() => {
    if (doGetCoreValuesList) {
      doGetCoreValuesList();
    }
  }, [doGetCoreValuesList]);

  return (
    <HeaderComponent
      title="Our Core Values"
      titleClass="text-[16px] font-medium"
      description="The principles that guide everything we do at Hyvid"
      descriptionClass="text-sm muted-text"
    >
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {coreValuesList?.map((item) => {
          const meta = CORE_VALUE_META[item.label] || {};

          return (
            <Card
              key={item.value}
              className={`card-theme ${meta.color} rounded-xl cursor-pointer hover:shadow-lg transition-all`}
            >
              <div className="space-y-4">
                <div className="flex flex-col items-start gap-3">
                  <div className="icon-style p-3 text-white">
                    {meta.icon &&
                      USABLE_ICONS[meta.icon] &&
                      React.createElement(USABLE_ICONS[meta.icon], {
                        className: "h-6 w-6",
                      })}
                  </div>

                  <h4 className="card-text text-base">
                    {item.label}
                  </h4>

                  <p className="text-[13px] muted-text">
                    {item.description}
                  </p>
                </div>
              </div>
            </Card>
          );
        })}
      </div>
    </HeaderComponent>
  );
};

const mapStateToProps = (state) => ({
  coreValuesList: state.optionlist.coreValuesList?.items, 
});

const mapDispatchToProps = (dispatch) => ({
  doGetCoreValuesList: (data) => dispatch(getCoreValuesList(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(OurCoreValues);